module.exports = __webpack_public_path__ + "static/media/desarrollo.9e1c0036.jpg";